export default __webpack_public_path__ + "static/media/truck.f16aa5cc.svg";